import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters from './__generated__/StorageHardLimitsModalQuery.graphql';
import type { StorageHardLimitsModalEntryPointParams } from './type.tsx';

export const jiraStorageHardLimitsPopupModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "jira-storage-hard-limits-modal" */ './StorageHardLimitsModal.tsx'
			),
	),
	getPreloadProps: ({ cloudId, applicationKey }: StorageHardLimitsModalEntryPointParams) => ({
		queries: {
			StorageHardLimitsModalQuery: {
				parameters,
				variables: {
					cloudId,
					hamsProductKey: applicationKey,
				},
			},
		},
	}),
});
